import React, { useEffect, useState, useCallback } from "react";
import useGlobal from "../../store";
import { siteById, getSiteEquipment, getSiteZones, getSiteSpaces, updateSite, getBuildingsForSite, addSiteNote, getSiteNotes, getCommunicationInterfaces, getSiteContacts, associateSiteContact, updateInterface, addInterface, deleteInterface } from "../../services/MetadataService";
import { getAllProtocols, getAllPhysicalConnectionTypes, getAllUtilities } from "../../services/DimensionsServices"

import FloorMapView from "../../components/FloorMapView"
import LoadedSpaceList from "../../loaded/LoadedSpaceList"
import LoadedEquipmentList from "../../loaded/LoadedEquipmentList"

import { Autocomplete } from "@material-ui/lab";
import { Checkbox, IconButton, TextField } from "@material-ui/core";
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlankOutlined, ModeEdit, Settings } from "@mui/icons-material";

import { useHistory } from "react-router-dom";
import { getClimateZones, getNAICSCodes } from "../../services/AirtableService";
import ContactsList from "../../components/ContactsList";
import BuildingList from "../../components/BuildingList";
import ZoneList from "../../components/ZoneList"
import FileList from "../../components/FileList";
import { getEntityDocuments } from "../../services/FileService";
import {Auth} from "aws-amplify";
import Notes from "../../components/Notes";
import { LoadingButton } from "@mui/lab";
import CommunicationInterfacesList from "../../components/CommunicationInterfaceList";

const ShowLocation = (props) => {
    const [site, setSite] = useState()
    const [buildings, setBuildings] = useState()
    const [zones, setZones] = useState()
    const [files, setFiles] = useState()
    const [notes, setNotes] = useState();
    const [interfaces, setInterfaces] = useState();
    const[location, setLocation] = useState('Location')
    const[editMode, setEditMode] = useState(false)
    const[climateZones, setClimateZones] = useState()
    const[naicsCodes, setNAICSCodes] = useState()
    const[utilities, setUtilities] = useState()
    let [currentUser, setCurrentUser] = useState()

    let [currentState, currentActions] = useGlobal();
    let [isUpdating, setIsUpdating] = useState(false);
    let history = useHistory();

    const siteId = props && props.location
    useEffect(() => {
        if (!site) {
            siteById(siteId).then(response => {
                setSite(response)
            });
        }

        if (!buildings) {
            getBuildingsForSite(siteId).then(response => {
                setBuildings(response)
            })
        }

        getSiteNotes(siteId).then(response => {
			setNotes(response)
		})

        getSiteZones(siteId).then(response => {
            setZones(response);
        })

        getCommunicationInterfaces(siteId).then(response => {
            setInterfaces(response);
        })

        getAllUtilities().then(response => {
            setUtilities(response);
        });

        getFiles(siteId)

        if (!currentUser) {
            Auth.currentUserInfo().then(response => {
                setCurrentUser(response.attributes.name)
            })
        }
    }, [])


    const fetchContacts = useCallback(() => {
        return getSiteContacts(siteId);
    }, [siteId])

    const getFiles = (site_id) => {
        let siteId = site_id || site.site_id
        getEntityDocuments("locations/sites", siteId).then(response => {
            setFiles(response)
        })
    }

    useEffect(() => {
        if (!climateZones) {
            let zones = getClimateZones();
            setClimateZones(zones)
        }

        if (!naicsCodes) {
            let codes = getNAICSCodes();
            setNAICSCodes(codes)
        }

    }, [editMode])

    useEffect(() => {
        if (site) {
            currentActions.setSite(site)
        }
    },[site]) //We should probably do the same with spaces and equipment but for now will call separately

    useEffect(() => {
        if (currentState.currentModule !==  location) {
            currentActions.setCurrentModule(location)
        }
    },[location])

    const setArea = (area) => {
        let currentSite = Object.assign({}, site)
        currentSite.area = area
        setSite(currentSite)
    }

    const setHeight = (height) => {
        let currentSite = Object.assign({}, site)
        currentSite.floor_to_ceiling_height = height
        if (site.area) currentSite.volume = site.area * height
        setSite(currentSite)
    }

    const setEnrollment = (enrollment) => {
        let currentSite = Object.assign({}, site)
        currentSite.enrollment = enrollment
        setSite(currentSite)
    }

    const setCustomerCode = (code) => {
        let currentSite = Object.assign({}, site)
        currentSite.customer_code = code
        setSite(currentSite)
    }

    const setProjectCode = (code) => {
        let currentSite = Object.assign({}, site)
        currentSite.project_code = code
        setSite(currentSite)
    }

    const setFilesURL = (url) => {
        let currentSite = Object.assign({}, site)
        currentSite.files_url = url
        setSite(currentSite)
    }

    const setProjectURL = (url) => {
        let currentSite = Object.assign({}, site)
        currentSite.project_url = url
        setSite(currentSite)
    }

    const setDistributionEmail = (email) => {
        let currentSite = Object.assign({}, site)
        currentSite.distribution_email = email
        setSite(currentSite)
    }

    const setIsControlled = (e) => {
        let currentSite = Object.assign({}, site)
        currentSite.is_controlled = e.target.checked
        setSite(currentSite)
    }

    const setIsLowEnviroscore = (e) => {
        let currentSite = Object.assign({}, site)
        currentSite.is_low_enviroscore = e.target.checked
        setSite(currentSite)
    }

    const setIsLowIncome = (e) => {
        let currentSite = Object.assign({}, site)
        currentSite.is_low_income = e.target.checked
        setSite(currentSite)
    }

    const submitChanges = () => {
        setIsUpdating(true)
        updateSite(site).then(response => {
            setSite(response)
            setIsUpdating(false)
            setEditMode(false)
        })
    }

    const addNote = async (note) => {
		note.author = currentUser;
		addSiteNote(site.site_id, note).then(() => {
			getSiteNotes(site.site_id).then(response => {
				setNotes(response)
			})
		}).catch(err => {
			console.log(err)
		})

	}

    const addOrUpdateInterface = async (i) => {
        if (i.interface_id && i.interface_id > 0) {
            updateInterface(site.site_id, i).then(() => {
                getCommunicationInterfaces(site.site_id).then(response => {
                    setInterfaces(response)
                })
            })
        } else {
            addInterface(site.site_id, i).then(() => {
                getCommunicationInterfaces(site.site_id).then(response => {
                    setInterfaces(response)
                })
            })
        }
    }

    const deleteThisInterface = async (i) => {
        deleteInterface(i.interface_id).then(() => {
            getCommunicationInterfaces(site.site_id).then(response => {
                setInterfaces(response)
            })
        }).catch(err => {
            console.log(err)
        })      
    }   

    if (climateZones) {
        climateZones.sort((a,b) => a > b ? 1 : -1)
    }


    let defaultNaics = (site && naicsCodes && site.naics_code) ? naicsCodes.find(n => n.value === site.naics_code) : null
    let defaultUtility = (site && utilities && site.utility) ? utilities.find(u => u.id === site.utility.utility_id) : null
    return <div className="layer3">
            <div className="location">
                <FloorMapView key={site ? site.site_id : 0} siteId={site && site.site_id} />
                {  site ?
                <div className="space-stats">
                    <div className="section-header">
                        Stats
                        <div className="edit-element">
                            <IconButton
                                        variant="contained"
                                        color="primary"
                                        aria-label={"View and edit site settings" }

                                        onClick={() => {
                                            setEditMode(true)
                                    }}>
                                        <ModeEdit style={{fill: "#00b088", background: "white", transform: "scale(0.8)"}}/>
                            </IconButton>
                            <IconButton
                                        variant="contained"
                                        color="primary"
                                        aria-label={"View and edit site settings" }

                                        onClick={() => {
                                            history.push("/variables/site/" + site.site_id)
                                    }}>
                                        <Settings style={{fill: "#003e51", background: "white", transform: "scale(0.8)"}}/>
                            </IconButton>
                        </div>
                    </div>

                    <div className="stats-container">
                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="text" label="Customer Code" defaultValue={site && site.customer_code || ''} variant="outlined" size="small" onChange={(e) => {setCustomerCode(e.target.value)}}/>-
                                <TextField type="text" label="Project Code" defaultValue={site && site.project_code || ''} variant="outlined" size="small" onChange={(e) => {setProjectCode(e.target.value)}}/>
                            </div>
                            :
                        <div className="stat">
                            <div className="stat-label">Customer-Project</div>
                            <div className="stat-value">{site && site.customer_code || ''}-{site && site.project_code || ''}</div>
                        </div>
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="text" label="Google Drive URL" defaultValue={site && site.files_url || ''} variant="outlined" fullWidth onChange={(e) => {setFilesURL(e.target.value)}}/>
                                <TextField type="text" label="Monday Project URL" defaultValue={site && site.project_url || ''} variant="outlined" fullWidth onChange={(e) => {setProjectURL(e.target.value)}}/>
                                <TextField type="text" label="Distribution Email" defaultValue={site && site.distribution_email || ''} variant="outlined" fullWidth onChange={(e) => {setDistributionEmail(e.target.value)}}/>
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-value"><a href={site && site.files_url || ''}>Google Drive URL</a></div>
                                <div className="stat-value"><a href={site && site.project_url || ''}>Monday Project URL</a></div>
                                <div className="stat-value"><a href={site && 'mailto:' + site.distribution_email || ''}>Distribution Email</a></div>
                            </div>
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="number" label="Area" defaultValue={site && site.area} variant="outlined" size="small" onChange={(e) => {setArea(e.target.value)}}/>
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Area</div>
                                { site.area ?
                                    <div className="stat-value">{site.area} sqft</div> :
                                    <div className="stat-unavailable">Add default Value</div>
                                }
                            </div>
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="number" label="Floor to Ceiling Height" defaultValue={site && site.floor_to_ceiling_height} variant="outlined" size="small" onChange={(e) => {setHeight(e.target.value)}}/>
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Floor to Ceiling Height</div>
                                {site.floor_to_ceiling_height ?
                                    <div className="stat-value">{site.floor_to_ceiling_height} ft</div> :
                                    <div className="stat-unavailable">Add default Value</div> }
                            </div>
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <TextField type="number" label="Average Occupancy" value={site && site.enrollment || ''} variant="outlined" size="small" onChange={(e) => {setEnrollment(e.target.value)}}/>
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Average Occupancy</div>
                                {site.enrollment ?
                                    <div className="stat-value">{site && site.enrollment || ''}</div> :
                                    <div className="stat-unavailable">Add value</div> }
                            </div>
                        }

                        { editMode ?
                            <div className="stat-edit">
                                <Autocomplete
                                    disablePortal
                                    id="naics"
                                    options={naicsCodes}
                                    getOptionLabel={option => option && option.name }
                                    value={defaultNaics}
                                    renderInput={(params) => <TextField {...params} label="NAICS Code" variant="outlined" fullWidth size="small" />}
                                    style={{ width: "300px" }}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            console.log(newValue)
                                            let currentSite = Object.assign({}, site);
                                            currentSite.naics_code = newValue.value
                                            setSite(currentSite)
                                        }

                                    }}
                                />
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">NAICS Code</div>
                                {site && site.naics_code ?
                                    <div className="stat-value">{site.naics_code}</div> :
                                    <div className="stat-unavailable">Add value</div> }
                            </div>
                        }

                        {
                            editMode ?
                            <div className="stat-edit">
                                <Autocomplete
                                    disablePortal
                                    id="Climate"
                                    options={climateZones}
                                    value={site && site.climate_zone || ''}
                                    renderInput={(params) => <TextField {...params} label="Climate Zone" variant="outlined" fullWidth size="small" />}
                                    style={{ width: "200px" }}
                                    onChange={(event, newValue) => {
                                        let currentSite = Object.assign({}, site);
                                        currentSite.climate_zone = newValue
                                        setSite(currentSite)
                                    }}
                                />
                            </div>
                            :

                            <div className="stat">
                                <div className="stat-label">Climate Zone</div>
                                {site.climate_zone ?
                                    <div className="stat-value">{site && site.climate_zone}</div> :
                                    <div className="stat-unavailable">Add value</div> }
                            </div>
                        }
                        
                        { editMode ?
                            <div className="stat-edit">
                                <Autocomplete
                                    disablePortal
                                    id="utility"
                                    options={utilities}
                                    getOptionLabel={option => option && option.decorated_name }
                                    value={defaultUtility}
                                    renderInput={(params) => <TextField {...params} label="Utility" variant="outlined" fullWidth size="small" />}
                                    style={{ width: "300px" }}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            console.log(newValue)
                                            let currentSite = Object.assign({}, site);
                                            currentSite.utility = {
                                                utility_id: newValue.id,
                                                name: newValue.name

                                            }
                                            setSite(currentSite)
                                        }

                                    }}
                                />
                            </div>
                            :
                            <div className="stat">
                                <div className="stat-label">Utility</div>
                                {site && site.utility ?
                                    <div className="stat-value">{site.utility && site.utility.name}</div> :
                                    <div className="stat-unavailable">Add value</div> }
                            </div>
                        }

                        <div className="stat">
                            <div className="stat-label">Controllable?</div>
                        {
                            editMode ?
                            <div className="stat-edit">
                                <Checkbox defaultChecked={site && site.is_controlled} variant="outlined" size="small" onChange={setIsControlled}/>
                            </div>
                            :
                            <div className="stat-value">{site && site.is_controlled ? <CheckBoxIcon /> : <CheckBoxOutlineBlankOutlined />}</div>
                        }
                        </div>
                        {
                            editMode ?
                            <div className="stat">
                                <LoadingButton 
                                    variant="contained" 
                                    loading={isUpdating} 
                                    onClick={submitChanges} 
                                    sx={{backgroundColor: "#003e51"}}>
                                Submit</LoadingButton>
                            </div>
                            :
                            null
                        }
                    </div>
                </div>
                : null }
                <ContactsList
                    fetchContacts={fetchContacts}
                    associateContact={(email) => { return associateSiteContact(site && site.site_id, email)}}
                />
                <ZoneList siteId={props.location} zones={zones} />
                <BuildingList buildings={buildings} siteId={props.location} />
                <LoadedSpaceList siteId={props.location} />
                <LoadedEquipmentList siteId={props.location} />
                <Notes notes={notes} onSubmit={addNote} />
                <FileList files={files} context="site" id={site && site.site_id} filesAccessor={getFiles} />
                <CommunicationInterfacesList 
                    interfaces={interfaces} 
                    id={site && site.site_id} 
                    addOrUpdateInterfaceCallback={addOrUpdateInterface} 
                    getAllProtocols={getAllProtocols} 
                    getAllPhysicalConnectionTypes={getAllPhysicalConnectionTypes} 
                    deleteInterfaceCallback={deleteThisInterface} />

            </div>
        </div>

}

export default ShowLocation;
